import { render } from "./KalaSearch.vue?vue&type=template&id=1c4afdcc&scoped=true"
import script from "./KalaSearch.vue?vue&type=script&lang=js"
export * from "./KalaSearch.vue?vue&type=script&lang=js"

import "./KalaSearch.vue?vue&type=style&index=0&id=1c4afdcc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4afdcc"]])

export default __exports__